export enum WorkflowType {
  initialStep =         0,
  approval =            1,
  form =                2,
  formSection =         3,
  payment =             4,
  licenseStatusChange = 5, // maps to back-end award step
  certificate =         6,
  mapping =             7,
  processFlow =         8,
}

export const WorkflowTypesWithLinkedDocuments = [
  WorkflowType.form,
  WorkflowType.approval,
  WorkflowType.formSection,
  WorkflowType.certificate,
  WorkflowType.licenseStatusChange,
  WorkflowType.mapping,
  WorkflowType.processFlow,
  WorkflowType.initialStep,
]